export const ErrorCodes = {
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  USER_LOGIN_NOT_VERIFIED: "USER_LOGIN_NOT_VERIFIED",
  WALLET_NOT_SUPPORTED: "WALLET_NOT_SUPPORTED",

  // TRANSACTION ERRORS
  USER_REJECTED_TRANSACTION: "USER_REJECTED_TRANSACTION",
  TRANSACTION_ERROR: "TRANSACTION_ERROR",

  // SIGNATURE ERRORS
  USER_REJECTED_SIGNATURE: "USER_REJECTED_SIGNATURE",
  SIGNATURE_ERROR: "SIGNATURE_ERROR",

  // AUTH ERRORS (shared between sendAuthCode, signUp, signIn)
  AUTH_BAD_AUTHENTICATION: "AUTH_BAD_AUTHENTICATION",
  AUTH_ROLE_NOT_FOUND: "AUTH_ROLE_NOT_FOUND",
  AUTH_USER_ALREADY_REGISTERED: "AUTH_USER_ALREADY_REGISTERED",
  AUTH_USER_NOT_FOUND: "AUTH_USER_NOT_FOUND",
  AUTH_BAD_INPUT_PARAMETER: "AUTH_BAD_INPUT_PARAMETER",
  AUTH_BAD_TYPE_RENDERED: "AUTH_BAD_TYPE_RENDERED",
  AUTH_COMMON_ERROR: "AUTH_COMMON_ERROR",
  AUTH_BAD_AUTH_CODE_TYPE: "AUTH_BAD_AUTH_CODE_TYPE",
  AUTH_RATE_LIMIT_EXCEEDED: "AUTH_RATE_LIMIT_EXCEEDED",

  // USER ERRORS
  USER_NOT_AUTHENTICATED: "USER_NOT_AUTHENTICATED",
  USER_NOT_GRANTED: "USER_NOT_GRANTED",
  USER_KYC_SESSION_NOT_FOUND: "USER_KYC_SESSION_NOT_FOUND",
  USER_NOT_GRANTED_TO_VIEW_INFO: "USER_NOT_GRANTED_TO_VIEW_INFO",
  USER_BAD_INPUT_PARAMETER: "USER_BAD_INPUT_PARAMETER",
  USER_BAD_TYPE_RENDERED: "USER_BAD_TYPE_RENDERED",
  USER_COMMON_ERROR: "USER_COMMON_ERROR",

  // SUBSCRIPTION ERRORS
  SUBSCRIPTION_PLAN_NOT_FOUND: "SUBSCRIPTION_PLAN_NOT_FOUND",
  SUBSCRIPTION_ALREADY_EXISTS: "SUBSCRIPTION_ALREADY_EXISTS",
  SUBSCRIPTION_INVALID_PAYMENT_PROVIDER: "SUBSCRIPTION_INVALID_PAYMENT_PROVIDER",
  SUBSCRIPTION_PAYMENT_GATEWAY_ERROR: "SUBSCRIPTION_PAYMENT_GATEWAY_ERROR",
  SUBSCRIPTION_NOT_FOUND: "SUBSCRIPTION_NOT_FOUND",
  SUBSCRIPTION_NOT_ACTIVE: "SUBSCRIPTION_NOT_ACTIVE",
  SUBSCRIPTION_INVALID_REDIRECT_URL: "SUBSCRIPTION_INVALID_REDIRECT_URL",
  SUBSCRIPTION_COMMON_ERROR: "SUBSCRIPTION_COMMON_ERROR",
} as const

export type ErrorCodes = (typeof ErrorCodes)[keyof typeof ErrorCodes]
